/**
 * What a Home list says when it has no rows: one muted line, a row's height.
 *
 * @module components/home/HomeListEmpty
 */
import type { ReactNode } from "react";

import type { HomeFindingsStatus } from "./HomeFindings.logic";

export function HomeListEmpty({ children }: { readonly children: ReactNode }) {
  return <p className="flex h-9 items-center px-2 text-[14px] text-muted-foreground">{children}</p>;
}

/** A findings list before it can show rows: loading, or failed with a way to try again, never "none". */
export function HomeFindingsPending({
  status,
  onRetry,
}: {
  readonly status: Exclude<HomeFindingsStatus, "ready">;
  readonly onRetry: () => void;
}) {
  if (status === "loading") return <HomeListEmpty>Loading…</HomeListEmpty>;
  return (
    <p role="alert" className="flex h-9 items-center gap-2 px-2 text-[14px] text-muted-foreground" data-home-findings-unavailable="">
      Findings could not be loaded.
      <button
        type="button"
        onClick={onRetry}
        className="rounded text-foreground underline-offset-2 outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring"
      >
        Try again
      </button>
    </p>
  );
}
